import { useStaticQuery, graphql } from "gatsby"

export const useFooterMetadata = () => {
  const footerData = useStaticQuery(
    graphql`
      query footerMetaData {
        wpPage(id: { eq: "cG9zdDoxNTMyMzc=" }) {
          id
          title
          slug
          FooterpageFields {
            fieldGroupName
            footerContent
            footerSvgLogoShow
            footerLogo
            footerImage {
              altText
              mediaItemUrl
            }

            footerSocialTitle
            footerMenuList {
              footerMenuListTitle
              menuList {
                footerMenuListTitle
                footerMenuListLink {
                  url
                }
              }
            }
            footerSocialIcons {
              footerIcon
              footerIconLink {
                url
              }
            }
            footerClutchList {
              footerClutchIcon
              footerClutchRating
            }
          }
        }
      }
    `
  )

  return footerData
}
